"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconProps = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconModule = _interopRequireDefault(require("./icon.module.less"));

var _excluded = ["size", "color", "className", "textAligned"];

var useIconSize = function useIconSize(size) {
  switch (size) {
    case 'small':
      // 16px
      return '1rem';

    case 'medium':
      // 24px
      return '1.5rem';

    case 'large':
      // 32px
      return '2rem';

    case 'x-large':
      // 56px
      return '3.5rem';

    default:
      return size;
  }
};

var useIconProps = function useIconProps(_ref) {
  var _classNames;

  var size = _ref.size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      className = _ref.className,
      textAligned = _ref.textAligned,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var resolvedSize = useIconSize(size);
  return (0, _objectSpread2.default)({
    'aria-hidden': 'true',
    className: (0, _classnames.default)(className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _iconModule.default.sized, size === undefined), (0, _defineProperty2.default)(_classNames, _iconModule.default.textAligned, textAligned), _classNames)),
    fill: color,
    focusable: 'false',
    width: resolvedSize,
    height: resolvedSize
  }, props);
};

exports.useIconProps = useIconProps;